import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions';
import flattenAmountBifurcation from '../../utils/flattenAmountBifurcation';
import { buildBifurcationParams } from '../../utils/servicePlatformUtils';
import {
  IMAGE_URL_PREFIX,
  BIFURCATION_TYPE_CART_TOTAL,
  BIFURCATION_TYPE_TOTAL_PAYABLE,
  BIFURCATION_TYPE_DISCOUNT,
  BIFURCATION_TYPE_PROMO_DISCOUNT,
} from '../../constants';
import './ServiceRHS.scss';
import '../../components/DiagnosticsCart/DiagnosticsPromoBox.scss';
import '../../components/DiagnosticsCart/CartFooter.scss';

const staticText = {
  summarySuffix: ' Summary',
  cartTotal: 'Cart Total',
  discount: 'Discount',
  amountToBePaid: 'Amount to be paid',
  promoPlaceholder: 'Enter promocode here',
  apply: 'APPLY',
  remove: 'REMOVE',
  promoApplied: 'Promo applied!',
  invalidCode: 'Invalid Code!',
  totalItems: 'Total Items',
  totalSavings: 'Total Savings',
  totalCartValue: 'Total Cart Value',
  fallbackDash: '—',
  fallbackSavings: '₹0',
};


class ServiceRHS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      promoInput: '',
      promoApplied: false,
      promoMessage: '',
      promoLoading: false,
    };
  }

  componentDidMount() {
    const { servicePlatform, actions } = this.props;
    const { service, selectedPackage } = servicePlatform;
    if (service && service.serviceId && service.vendorId && selectedPackage) {
      actions.fetchServiceBifurcation(buildBifurcationParams(service, selectedPackage, null));
    }
  }

  componentDidUpdate(prevProps) {
    const { servicePlatform, actions } = this.props;
    const { service, selectedPackage } = servicePlatform;
    const packageChanged = selectedPackage && selectedPackage !== prevProps.servicePlatform.selectedPackage;
    const vendorIdArrived = service.vendorId && !prevProps.servicePlatform.service.vendorId;
    if (packageChanged || vendorIdArrived) {
      if (packageChanged) this.setState({ promoInput: '', promoApplied: false, promoMessage: '' });
      if (selectedPackage) actions.fetchServiceBifurcation(buildBifurcationParams(service, selectedPackage, null));
    }
  }

  applyPromo = () => {
    const { promoInput, promoLoading } = this.state;
    if (promoLoading) return;
    if (!promoInput || promoInput.length < 3) {
      this.setState({ promoMessage: staticText.invalidCode });
      return;
    }
    const { servicePlatform, actions } = this.props;
    const { service, selectedPackage } = servicePlatform;
    this.setState({ promoLoading: true, promoMessage: '' });
    actions.fetchServiceBifurcation(buildBifurcationParams(service, selectedPackage, promoInput));
    this.setState({ promoApplied: true, promoLoading: false, promoMessage: staticText.promoApplied });
  }

  removePromo = () => {
    const { servicePlatform, actions } = this.props;
    const { service, selectedPackage } = servicePlatform;
    this.setState({ promoInput: '', promoApplied: false, promoMessage: '', promoLoading: false });
    actions.fetchServiceBifurcation(buildBifurcationParams(service, selectedPackage, null));
  }

  render() {
    const { servicePlatform } = this.props;
    const { promoInput, promoApplied, promoMessage, promoLoading } = this.state;
    const { service, selectedPackage, selectedSlot, bifurcationData, bifurcationLoading } = servicePlatform;

    if (!service || !selectedPackage) return <div className="serviceRHS" />;

    const discount = selectedPackage.mrp > selectedPackage.sellingPrice
      ? Math.round(((selectedPackage.mrp - selectedPackage.sellingPrice) / selectedPackage.mrp) * 100) : 0;
    const attrs = selectedPackage.attributes || {};
    const homeVisitSessions = attrs.homeVisitSessions;
    const onlineSessions = attrs.onlineSessions;

    const invoice = flattenAmountBifurcation((bifurcationData && bifurcationData.amountBifurcation) || []);
    // type comes as string ("0","3","2") from service platform API — use == not ===
    const cartTotalItem = invoice.find(lineItem => Number(lineItem.type) === BIFURCATION_TYPE_CART_TOTAL && lineItem.identifier === 18);
    const discountItem = invoice.find(lineItem => Number(lineItem.type) === BIFURCATION_TYPE_DISCOUNT || Number(lineItem.type) === BIFURCATION_TYPE_PROMO_DISCOUNT || (lineItem.text && /discount/i.test(lineItem.text) && Number(lineItem.type) !== BIFURCATION_TYPE_CART_TOTAL));
    const totalItem = invoice.find(lineItem => Number(lineItem.type) === BIFURCATION_TYPE_TOTAL_PAYABLE) || null;
    const savingsDisplay = discountItem ? (discountItem.displayValue || discountItem.finalValue) : null;

    return (
      <div className="serviceRHS">
        <div className="serviceScrollArea">
          <p className="serviceHeading">{service.displayName}{staticText.summarySuffix}</p>

          <div className="odCard">
            <div className="odHeader">
              <div className="odTitle">{selectedPackage.name}</div>
            </div>
            <div className="odPriceRow">
              <span className="odPrice">₹{selectedPackage.sellingPrice}</span>
              {selectedPackage.mrp > selectedPackage.sellingPrice && (
                <span className="odOriginal">₹{selectedPackage.mrp}</span>
              )}
              {discount > 0 && (
                <span className="odDiscount">{discount}%</span>
              )}
            </div>
            {selectedPackage.perSessionPrice > 0 && attrs.showPerSessionsPrice && (
              <div className="odPerSession">
                ₹{selectedPackage.perSessionPrice} per {attrs.variantsText || 'session'}
              </div>
            )}
            {service.hasSlots && selectedSlot && selectedSlot.date && (
              <div className="odSlotInfo">
                {selectedSlot.date}{selectedSlot.startTime ? `, ${selectedSlot.startTime}` : ''}
              </div>
            )}
            {(homeVisitSessions || onlineSessions) && (
              <div className="odFeatures">
                {homeVisitSessions && homeVisitSessions.count > 0 && (
                  <div className="odFeatureItem">
                    <img
                      src={`${IMAGE_URL_PREFIX}service-platform/icon_Home.png`}
                      alt="home"
                      width={40}
                      height={40}
                    />
                    <div>
                      <div className="odFeatureValue">{homeVisitSessions.count}</div>
                      <div className="odFeatureLabel">{homeVisitSessions.title}</div>
                    </div>
                  </div>
                )}
                {onlineSessions && onlineSessions.count > 0 && (
                  <div className="odFeatureItem">
                    <img
                      src={`${IMAGE_URL_PREFIX}service-platform/icon_Online_Consult.png`}
                      alt="online"
                      width={40}
                      height={40}
                    />
                    <div>
                      <div className="odFeatureValue">{onlineSessions.count}</div>
                      <div className="odFeatureLabel">{onlineSessions.title}</div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Bifurcation table — same classes as DocConsultRHS */}
          {!bifurcationLoading && invoice.length > 0 && (
            <div className="dcBifurcationTable">
              <div className="dcBifurcationRow">
                <span>{staticText.cartTotal}</span>
                <span>{cartTotalItem
                  ? (cartTotalItem.displayValue || cartTotalItem.finalValue)
                  : `₹${selectedPackage.sellingPrice}`}
                </span>
              </div>
              <div className="dcBifurcationRow">
                <span>{staticText.discount}</span>
                <span>{discountItem ? (discountItem.displayValue || discountItem.finalValue) : staticText.fallbackDash}</span>
              </div>
              <div className="dcBifurcationRow">
                <span>{staticText.amountToBePaid}</span>
                <span>{totalItem ? (totalItem.displayValue || totalItem.finalValue) : staticText.fallbackDash}</span>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="footerDetails">
          <div className="DiagnosticsPromoBoxContainer">
            <div className="InputContainer">
              <input
                type="text"
                value={promoInput}
                placeholder={staticText.promoPlaceholder}
                disabled={promoApplied}
                onChange={e => this.setState({ promoInput: e.target.value, promoMessage: '' })}
                onKeyPress={e => e.which === 13 && !promoApplied ? this.applyPromo() : null}
              />
              <button
                className={promoLoading ? 'loading' : ''}
                onClick={promoApplied ? this.removePromo : this.applyPromo}
              >
                {promoApplied ? staticText.remove : staticText.apply}
              </button>
            </div>
            {promoApplied
              ? <div className="SuccessText">{promoMessage}</div>
              : <div className="ErrorText">{promoMessage}</div>
            }
          </div>

          <div className="summary">
            <div className="itemContainer">
              <div className="textTitle">{staticText.totalItems}</div>
              <div className="textTitle textbold">1</div>
            </div>
            <div className="itemContainer">
              <div className="textTitle textGreen">{staticText.totalSavings}</div>
              <div className="textTitle textbold textGreen">{savingsDisplay || staticText.fallbackSavings}</div>
            </div>
            <div className="itemContainer">
              <div className="textTitle">{staticText.totalCartValue}</div>
              <div className="textTitle textbold">
                {totalItem ? (totalItem.displayValue || totalItem.finalValue) : `₹${selectedPackage.sellingPrice}`}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ServiceRHS.propTypes = {
  servicePlatform: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default connect(
  state => ({ servicePlatform: state.servicePlatform }),
  dispatch => ({ actions: bindActionCreators(actions, dispatch) })
)(ServiceRHS);
